import {useMemo} from 'react';
import {orderBy} from 'lodash';

export const useFilterOptions = (filterOptions = {}) => {
	// Sort brands by quantity (top 5) then alphabetically
	const sortedBrands = useMemo(() => {
		if (!filterOptions?.brands?.length) return [];

		const sorted = orderBy(filterOptions.brands, ['product_quantity'], ['desc']);
		const top5 = sorted.slice(0, 5);
		const rest = orderBy(sorted.slice(5), ['label'], ['asc']);

		return [...top5, ...rest];
	}, [filterOptions?.brands]);

	// Sort all lists alphabetically
	const sortedLists = useMemo(() => ({
		categories: filterOptions?.categories?.slice()?.sort((a, b) =>
			a.label.localeCompare(b.label)) || [],
		subcategories: filterOptions?.subcategories?.slice()?.sort((a, b) =>
			a.label.localeCompare(b.label)) || [],
		brands: sortedBrands,
		countries: filterOptions?.countries?.slice()?.sort((a, b) =>
			a.label.localeCompare(b.label)) || [],
		dietary: filterOptions?.dietary?.slice()?.sort((a, b) =>
			a.label.localeCompare(b.label)) || [],
	}), [filterOptions, sortedBrands]);

	const sortOptions = useMemo(() => [
		{id: 0, label: "Sort", value: ""},
		{id: 1, label: "Name (A to Z)", value: "a-z"},
		{id: 2, label: "Name (Z to A)", value: "z-a"},
		{id: 3, label: "Price (Low to High)", value: "low-high"},
		{id: 4, label: "Price (High to Low)", value: "high-low"},
	], []);

	return {sortedLists, sortOptions};
};